<div
  class="sticky top-0 bg-transparent shadow-lg rounded-lg p-4 max-w-screen-xl mx-auto"
>
  <div class="flex gap-4 items-center">
    
      <input nzSize="large"
        [formControl]="filteringControl"
        (keydown.enter)="filterOnEnter()"
        type="text"
        nz-input
        placeholder="Event name / Performer / Location"
      />
  </div>
</div>
